// blocksMap.ts
import { SSH_Text } from "@danishagro/sharedShop/src/blocks/components/Text";
import { SSH_Departments } from "@danishagro/sharedShop/src/blocks/components/DepartmentsList";
import { SSH_DepartmentMap } from "@danishagro/sharedShop/src/blocks/components/DepartmentMap";
import { SSH_BlockImage } from "@danishagro/sharedShop/src/blocks/components/Image";
import { SSH_TextText } from "@danishagro/sharedShop/src/blocks/components/TextText";
import { SSH_Hero } from "@danishagro/sharedShop/src/blocks/components/Hero";
import { SSH_ContentList } from "@danishagro/sharedShop/src/blocks/components/ContentList";
import { SSH_CampaignList } from "@danishagro/sharedShop/src/blocks/components/CampaignList";
import { SSH_Spots } from "@danishagro/sharedShop/src/blocks/components/Spots";
import { SSH_TextImage } from "@danishagro/sharedShop/src/blocks/components/TextImage";
import { SSH_TextVideo } from "@danishagro/sharedShop/src/blocks/components/TextVideo";
import { SSH_UspList } from "@danishagro/sharedShop/src/blocks/components/UspList";
import { DA_CategorySlider } from "@organisms/CategorySlider";
import { BlockProducts } from "@organisms/BlockProducts";
import { SSH_SeoTitle } from "@danishagro/sharedShop/src/blocks/components/Seo/Title";
import { SSH_SeoShortDescription } from "@danishagro/sharedShop/src/blocks/components/Seo/ShortDescription";
import { SSH_SeoLongDescription } from "@danishagro/sharedShop/src/blocks/components/Seo/LongDescription";
import { SSH_PlpHeadline } from "@danishagro/sharedShop/src/blocks/components/PLP/Headline";
import { SSH_Embed } from "@danishagro/sharedShop/src/blocks/components/Embed";
import { SSH_BlockMyProfile } from "@danishagro/sharedShop/src/blocks/components/MyProfile";
import { SSH_BlockOrderHistory } from "@danishagro/sharedShop/src/blocks/components/OrderHistory";
import { SSH_BlockUserInvitation } from "@danishagro/sharedShop/src/blocks/components/UserInvitation";
import { SSH_TextForm } from "@danishagro/sharedShop/src/blocks/components/TextForm";

// To keep it type-safe, we can map alias -> React Component
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const BLOCK_MAP: Record<string, React.FC<any>> = {
    blockText: SSH_Text,
    blockDepartmentList: SSH_Departments,
    blockDepartmentMap: SSH_DepartmentMap,
    blockImage: SSH_BlockImage,
    blockTextText: SSH_TextText,
    blockHero: SSH_Hero,
    blockContentList: SSH_ContentList,
    campaignList: SSH_CampaignList,
    blockSpotsPage: SSH_Spots,
    blockSpots: SSH_UspList,
    blockTextImage: SSH_TextImage,
    blockTextVideo: SSH_TextVideo,
    blockProducts: BlockProducts,
    blockProductsHatting: BlockProducts,
    blockCategories: DA_CategorySlider,
    blockPLPSeoTitle: SSH_SeoTitle,
    blockPLPSeoShortDescription: SSH_SeoShortDescription,
    blockPLPSeoDescription: SSH_SeoLongDescription,
    blockPLPHeadline: SSH_PlpHeadline,
    blockEmbed: SSH_Embed,
    blockMyProfile: SSH_BlockMyProfile,
    blockOrderHistory: SSH_BlockOrderHistory,
    blockUserInvitation: SSH_BlockUserInvitation,
    blockTextForm: SSH_TextForm,
    // etc.
};
